import { chakra, HTMLChakraProps } from "@chakra-ui/react";
import * as React from "react";

export const Calendar = (props: HTMLChakraProps<"svg">) => {
  return (
    <chakra.svg
      width="4"
      height="4"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.333 1.99996H13.9997C14.1765 1.99996 14.3461 2.0702 14.4711 2.19522C14.5961 2.32025 14.6663 2.48981 14.6663 2.66663V13.3333C14.6663 13.5101 14.5961 13.6797 14.4711 13.8047C14.3461 13.9297 14.1765 14 13.9997 14H1.99967C1.82286 14 1.65329 13.9297 1.52827 13.8047C1.40325 13.6797 1.33301 13.5101 1.33301 13.3333V2.66663C1.33301 2.48981 1.40325 2.32025 1.52827 2.19522C1.65329 2.0702 1.82286 1.99996 1.99967 1.99996H4.66634V0.666626H5.99967V1.99996H9.99967V0.666626H11.333V1.99996ZM9.99967 3.33329H5.99967V4.66663H4.66634V3.33329H2.66634V5.99996H13.333V3.33329H11.333V4.66663H9.99967V3.33329ZM13.333 7.33329H2.66634V12.6666H13.333V7.33329Z"
        fill="#4B5563"
      />
    </chakra.svg>
  );
};
